module.exports = __webpack_public_path__ + "media/images/RedWomanUmbrellaComp-06cba4450c452cb7bd13800b6d469203.png";